/*
 *   File : form-otp.js
 *   Author URI : https://evoqins.com
 *   Description : Nominee OTP modal from KYC flow
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";

import { GradientButton } from "../Cta";
import Icon from "../Icon/icon";
import { OTPInput } from "../FormElements";


import style from "../../Styles/Components/unlock.module.scss";


const FatcaOTPVerification = (props) => {

    const firstPINref = useRef(null);

    const [pinString, setPinString] = useState("");
    const [buttonLoader, setButtonLoader] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [seconds, setSeconds] = useState(30);

    useEffect(() => {
        var my_modal = document.getElementById("form-otp");
        my_modal.addEventListener("shown.bs.modal", () => {
            setSeconds(29);
        });
    }, []);

    useEffect(() => {
        const countdown = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            } else {
                clearInterval(countdown);
                // Handle expiration logic here (e.g., show a resend button)
            }
        }, 1000);

        return () => {
            clearInterval(countdown);
        };
    }, [seconds]);


    // modal close listener
    useEffect(() => {
        const my_modal = document.getElementById("form-otp");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
            setPinString('');
        });
    }, []);

    // update button loading status 
    useEffect(() => {
        setButtonLoader(props.loader);
    }, [props.loader]);

    useEffect(() => {
        const _handleKeyPress = (event) => {
            // Check if Ctrl key (or Command key on Mac) is pressed and 'a' key is pressed
            if (event.ctrlKey && event.key === 'a') {
                event.preventDefault(); // Prevent the default behavior (text selection)
            }
        };

        // Attach the event listener to the modal content
        const modalContent = document.getElementById('form-otp');

        modalContent.addEventListener('keydown', _handleKeyPress);

        // Clean up the event listener when the component is unmounted
        return () => {
            modalContent.removeEventListener('keydown', _handleKeyPress);
        };
    }, []);

    // handle function pin input
    const _handlePin = (value) => {
        setPinString(value);
        setErrorMessage("");
    }

    function _handleResend() {

        setPinString("");
        setSeconds(30);
        props.resendOtp(true);

    }


    // submit button click 
    async function _verifyPin() {
        if (pinString.length !== 4) {
            setErrorMessage("Please enter OTP");
            return;
        }
        setButtonLoader(true);
        try {
            const result = await props.handleOTPSubmission(pinString);
            // closing modal after api call;
            if (result === true) {
                const close_button = document.getElementById("close-modal");
                close_button.click();
                props.handleSuccess()
                // } else {
                //     setPinString("");
            }

        } catch (error) {
            // setPinString("");
        }
        setButtonLoader(false);
    }

    return (
        <div id="form-otp"
            // data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="form-otp"
            aria-hidden="true"
            className={`modal fade ${style.e_unlock}`}>
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content p-4 ${style.e_content} `}>
                    <Icon icon="close"
                        size={24}
                        data-bs-dismiss="modal"
                        className={`position-absolute cursor-pointer e-modal-close-btn right-24`}
                    />
                    <div className="text-center">
                        <img draggable={false} src={require("../../Assets/Images/Modal/pin_illustration.png")}
                            alt="Kyc success"
                            width={72}
                            height={72}
                            className="mx-auto mb-5 mt-3" />

                        <p className="color-eerie-black e-poppins-medium e-font-18 mb-2 mt-3">Enter OTP you have received in registered email and phone number</p>


                        <p className="color-outer-space e-poppins-regular e-font-14 mb-4 margin-20px-top">
                            Enter OTP you have received in registered email and phone number
                        </p>
                    </div>

                    <button className="d-none" data-bs-dismiss="modal" id="close-modal"></button>
                    <div className="d-flex flex-column align-items-center text-start">
                        <OTPInput pinString={pinString}
                            id="sip-otp"
                            autoFocus={true}
                            pinError={errorMessage}
                            disabled={buttonLoader}
                            handleChange={_handlePin} />


                        <div className="col-10 d-flex justify-content-center">
                            <GradientButton label="Confirm OTP"
                                loading={buttonLoader}
                                className=" padding-14px-tb margin-32px-top"
                                onPress={_verifyPin} />
                        </div>

                        <div className="d-flex justify-content-center mt-4">
                            {
                                seconds === 0 ?
                                    <p className='color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-pointer mb-0 e-forgot-pin position-relative w-max-content'
                                        onClick={_handleResend}>Resend OTP</p>
                                    :
                                    <p className='color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-not-allowed mb-0 '>
                                        Resend OTP in <span className="color-black">{seconds}s</span>
                                    </p>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

FatcaOTPVerification.defaultProps = {
    handleSuccess: () => { },
    handleOTPSubmission: () => { }
}

export default FatcaOTPVerification;